import React from 'react';

const RegisterTitle = ({ record }) => {
	return <span>Register {record ? `"${record.name}"` : ''}</span>;
};
export default RegisterTitle;
